import { AttachmentMeta } from "@/indexedDB/types";

import { Paperclip } from "lucide-react";

type Props = {
  messageId: string;
  chatId: string;
  attachment: AttachmentMeta;
};

export default function FileAttachment({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  messageId,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  chatId,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  attachment,
}: Props) {
  // const [loading, setLoading] = useState<boolean>(true);
  // const [attachmentBlob, setAttachmentBlob] = useState<Blob | null>(null);
  // const avatarUrlFromBlob = useBlobToImageURL(attachmentBlob);

  // TO DO => improve logic and spinner extraction

  return (
    <div className="relative aspect-square size-10 rounded-xl border border-secondary">
      <div className="z-5 absolute left-0 top-0 flex aspect-square size-full items-center justify-center rounded-sm align-middle">
        <Paperclip className="size-4 text-secondary" />
      </div>
    </div>
  );
}
